import { ListItem } from "../elements/ListItem";

export function ChooseSpinnerPage({
  spinnerList,
  chooseSpinner,
  deleteSpinner,
}) {
  const elementList = [];
  for (const i in spinnerList) {
    elementList.push(
      <ListItem
        key={i}
        buttonImg="cross.png"
        buttonOnClick={() =>
          deleteSpinner(spinnerList[i].id, spinnerList[i].name)
        }
        textOnClick={() =>
          chooseSpinner(spinnerList[i].id, spinnerList[i].name)
        }
        text={spinnerList[i].name}
      />,
    );
  }

  return <div className="sidecontent list">{elementList}</div>;
}
